import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanDeactivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable()
export class PreventBrowserHistoryNavigationGuard implements CanActivate, CanDeactivate<unknown> {
  constructor(private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    return this.isNavigationAllowed();
  }

  canDeactivate(
    _component: unknown,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    _nextState?: RouterStateSnapshot,
  ): boolean {
    return this.isNavigationAllowed();
  }

  private isNavigationAllowed(): boolean {
    return this.router.getCurrentNavigation()?.trigger !== 'popstate';
  }
}
